/*global SlimCD*/
/*eslint no-undef: "error"*/
import React, { useState,useEffect } from "react";

import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS, enAU, es } from "date-fns/locale";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import InputLabel from "@mui/material/InputLabel";
import { useToaster } from "../../toaster/MuiToasterProvider";
// import { brandColors } from "../../../_components/brandedComponent/BrandedColors";

import {
  savePaymentMethod,
  createPaymentMethod,
} from "../../../_redux/actions/paymentActions";
// import { CreditCardSwitch } from "@/_components";
// import { CreditCardSwitch } from "@/_components";
import { importScript } from "../../../_helpers/importScript";

import { green } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";

import InfoIcon from "@mui/icons-material/Info";
import { styled, useTheme } from "@mui/material/styles";
import CreditCard_Blue from "../../../_images/CreditCards/CreditCard_Blue.png";
import Mastercard_Logo from "../../../_images/CreditCards/Mastercard_Logo.png";
import Visa_Logo from "../../../_images/CreditCards/Visa_Logo.png";
import Discover_Logo from "../../../_images/CreditCards/Discover_Logo.png";
import CreditCardChipLogo from "../../../_images/CreditCards/CreditCard_Chip.png";
import Cvv2TooltipLogo from "../../../_images/CreditCards/CreditCard_SecCode.png";
import { logGeneralException } from "../../../_api/generalExceptionApi";
import ContinueButton from "../ContinueButton";
import Cookies from "universal-cookie";
import { Australia } from "../../../_helpers/CountryConstants";
// import Cookies from "universal-cookie";
// import { LifeSafer } from "../../../_helpers/BrandConstants";

const GreenCheckbox = styled(Checkbox)(() => ({
  color: green[400],
  "&.Mui-checked": {
    color: green[600],
  },
}));

const RedTextTypography = styled(Typography)({
  root: {
    fontSize: 16,
    color: "#d1495b",
    fontWeight: 600,
    fontStyle: "italic",
  },
});

// Root container
export const Root = styled("div")(({ theme }) => ({
  flexGrow: 1,
  // [theme.breakpoints.up("sm")]: { paddingTop: theme.spacing(4) },
  [theme.breakpoints.up("sm")]: { paddingLeft: theme.spacing(0) },
  [theme.breakpoints.up("sm")]: { paddingRight: theme.spacing(0) },
  [theme.breakpoints.up("md")]: { padding: theme.spacing(4) },
  [theme.breakpoints.down("md")]: { paddingTop: theme.spacing(2) },
}));

// Title typography
export const TitleTypo = styled("div")(({ theme }) => ({
  fontWeight: 600,
  [theme.breakpoints.up("sm")]: { fontSize: 18 },
  [theme.breakpoints.down("sm")]: { fontSize: 16 },
}));

// Header grid
export const HeaderGrid = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: { padding: "0 10px" },
}));

// Small credit card holder box
export const CreditCardHolder = styled("div")(() => ({
  width: 50,
  height: 32,
  border: "1px solid #1c355e",
  borderRadius: 4,
  backgroundColor: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
}));

// Credit card image inside holder
export const CreditCard = styled("img")(() => ({
  paddingTop: 2,
  paddingLeft: 2,
  width: 46,
  height: 28,
}));

// Main card background
export const CardHolder = styled("div")(() => ({
  height: 190,
  width: 320,
  borderRadius: 10,
  background: `url(${CreditCard_Blue})`,
  backgroundSize: "320px 190px",
  backgroundRepeat: "no-repeat",
  boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
}));

// Card chip image
export const CreditCardChip = styled("img")(() => ({
  marginLeft: 24,
  height: 36,
  width: 48,
}));

// Tooltip box
export const Cvv2Tooltip = styled("img")(() => ({
  width: 168,
  height: 130,
}));

// Label root and focused styles
export const LabelRoot = styled("label")(() => ({
  "&.Mui-focused": {
    fontWeight: 700,
  },
}));

export const StyledInputLabel = styled(InputLabel)(() => ({
  "&.Mui-focused": {
    fontWeight: 700,
  },
}));

export const WhiteTextTypography = styled(Typography)({
  root: {
    fontSize: 14,
    color: "#fff",
    fontWeight: 400,
  },
});

function UpsertPaymentMethod({
  user,
  items,
  paymentMethod,
  // editCancel,
  savePaymentMethod,
  createPaymentMethod,
  ccToken,
  appointmentData,
  handleUpdate,
}) {
  const classes = {};
  // const cookies = new Cookies();
  const [selectedDate, setSelectedDate] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [selectedDefault, setSelectedDefault] = useState(true);
  // const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;

  // const [billingDays, setBillingDays] = useState(14);
  const billingDays = 14;
  const [errors, setErrors] = useState({});
  const theme = useTheme();
  const isXtraSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const { t,i18n } = useTranslation();
  importScript("https://trans.slimcd.com/soft/json/slimcd.js");
  // const countryCode = sessionStorage.getItem("LSCountryCode");
  // const locale = countryCode === "USA" ? enUS : enAU;
  // const [ccToken, setCCToken] = useState(null);
  const toast = useToaster();
  const cookies = new Cookies();
    const siteCountry = cookies.get("siteCountry");
    const [locale, setLocale] = useState();
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltipCvv, setShowTooltipCvv] = useState(false);

  // useEffect(() => {
  //   isMountedRef.current = true;
  //   if (isMountedRef.current && user?.allowCC) {
  //     loadClientPaymentToken(user?.clientID || user?.ClientId)
  //       .then((ccToken) => {
  //         setCCToken(ccToken?.cC_Token);
  //       })
  //       .catch((error) => {
  //         console.log("Loading Payment Token failed! " + error);
  //       });
  //   }
  //   return () => (isMountedRef.current = false);
  // }, []);

  //  function SubmitHandler() {
  //    setActiveStep((prev)=>prev + 1)
  //   }

  function SubmitHandler() {
    event.preventDefault(); //This prevents any rerendering (postback)
    setErrors(null);
    //Get the date input value
    let formattedDate = new Date(selectedDate);
    let expmonth = (formattedDate.getMonth() + 1).toString().padStart(2, "0");
    let expyear = formattedDate.getFullYear();
    if (expyear < 2020) expyear = null;
    const identifiedErrors = {};
    // CHECK THE USER INPUT FOR VALIDITY
    if (
      SlimCD.Validate.isValidCardNumber(
        document.getElementById("cardnumber").value
      ) === false
    )
      identifiedErrors.cardnumber = true;

    if (SlimCD.Validate.isValidExpDate(expmonth, expyear) === false)
      identifiedErrors.expire = true;

    if (
      SlimCD.Validate.isValidCVV2(document.getElementById("cvv2").value) ===
      false
    )
      identifiedErrors.cvv2 = true;

    if (
      SlimCD.Validate.isValidZipCode(document.getElementById("zip").value) ===
      false
    )
      identifiedErrors.zip = true;

    setErrors(identifiedErrors);
    if (Object.keys(identifiedErrors).length === 0) {
      // Disable the controls so the user can't click
      setSubmitting(true);

      // SUBMIT THE USER INPUT TO SLIMCD USING A LOAD TRANSACTION TYPE
      SlimCD.Transact.ProcessTransaction(
        {
          username: ccToken,
          amount: "0.01", // You must authorize with at least $0.01
          transtype: "AUTH",
          cardnumber: document.getElementById("cardnumber").value,
          expmonth: expmonth,
          expyear: expyear,
          cvv2: document.getElementById("cvv2").value,
          zip: document.getElementById("zip").value,
        },
        function (reply) {
          // Approved or Declined a GateID will be returned
          // SAVE THE UNIQUE RETURNED GATEID AS THE TRANSACTION TOKEN IN A HIDDEN FIELD
          console.log(";i am reply", reply);
          if (
            reply.datablock !== undefined &&
            reply.datablock.gateid !== undefined
          )
            document.getElementById("gateid").value = reply.datablock.gateid;

          if (reply.response == "Success") {
            // CLEAR THE CARD NUMBER AND CVV2 FIELDS TO STAY OUT OF SCOPE
            document.getElementById("cardnumber").value = "";
            document.getElementById("cvv2").value = "";

            // SAVE THE RETURNED NON-SENSATIVE CARD INFORMATION
            document.getElementById("last4").value = reply.datablock.last4;
            document.getElementById("cardtype").value =
              reply.datablock.cardtype;

            // POST YOUR FORM TO YOUR SERVER
            handleGoodSubmit();
            // editCancel(true);
          } else {
            // ANNOUNCE THE PROBLEM
            toast.error(t("payments.ccVerificationError"));
            // Log exception to api
            if (user?.allowCC === true) {
              logGeneralException({
                portalId: 2,
                description:
                  "Credit Card Transaction Error: " + reply.description,
                source: "Client Portal Front",
                fileName: "UpsertPaymentMethod.jsx",
                functionName: "SlimCD.Transact.ProcessTransaction",
                notes: "Error with Credit Card Transaction",
                addBy: user.userId,
                clientID: user.clientID,
              });
            }
            setSubmitting(false);
          }
        }
      );
    }
  }
  // console.log(SubmitHandlerTest)

  function handleGoodSubmit() {
    let gateId = document.getElementById("gateid").value;
    let last4 = document.getElementById("last4").value;
    let cardType = document.getElementById("cardtype").value;

    let cardData = {
      clientID: user.clientID || user?.ClientId || user?.clientId,
      cardType: cardType,
      ccLastFour: last4,
      CreditCardStatus: selectedDefault === true ? "Active" : "OnFile",
      gateID: gateId,
      locationID: appointmentData[0]?.locationID || appointmentData[0]?.LocationID,
      billingDays: billingDays,
    };

    // 1. Is this an Edit or Add?
    let updatedPaymentMethod = paymentMethod?.filter(
      (x) => x.ccLastFour === cardData.ccLastFour
    );

    // 2. If Edit Update, If Add Insert
    if (updatedPaymentMethod?.length === 1) {
      let newData = { ...updatedPaymentMethod[0], ...cardData };
      // savePaymentMethod(newData.recurringPaymentCardID, newData);

      savePaymentMethod(newData.recurringPaymentCardID, newData)
        .then(() => {
          // setActiveStep((prev) => prev + 1);
          toast.success(t("toasts.cardUpdatedMessage"));
          handleUpdate("WrapUp");
        })
        .catch((e) => {
          console.log("error", e);
        });
    } else {
      // createPaymentMethod(cardData);
      createPaymentMethod(cardData)
        .then(() => {
          // setActiveStep((prev) => prev + 1);
          toast.success(t("toasts.cardUpdatedMessage"));
          handleUpdate("WrapUp");
        })
        .catch((e) => {
          console.log("error", e);
        });
    }

    // 3. Make sure if set to "Default" to update all other cards to Inactive
    if (selectedDefault === true) {
      let currentActive = paymentMethod?.filter(
        (x) =>
          x.CreditCardStatus === "Active" &&
          x.ccLastFour !== cardData.ccLastFour
      );

      if (currentActive?.length === 1) {
        let newStatus = { CreditCardStatus: "OnFile" };
        let newData = { ...currentActive[0], ...newStatus };
        handlePaymentMethodUpdate(newData); // Update optimistically
      }
    }

    // 4. Refresh the page
  }

  const handleCheckChange = (event) => {
    setSelectedDefault(event.target.checked);
  };

  // const handleBillingChange = (event) => {
  //   setBillingDays(event.target.value);
  // };

  const handlePaymentMethodUpdate = async (data) => {
    try {
      await savePaymentMethod(data.recurringPaymentCardID, data);
      // setActiveStep((prev) => prev + 1);
      handleUpdate("WrapUp");
    } catch (error) {
      toast.error(t("toasts.updateFailed") + ": " + error.message, {
        autoClose: false,
      });
    }
  };

   useEffect(() => {
    if (i18n.language.startsWith("en")) {
      if (siteCountry === Australia) {
        setLocale(enAU);
      } else {
        setLocale(enUS);
      }
    } else {
      setLocale(es);
    }
  }, [i18n.language]);

  return (
    <Root>
      <Grid container direction="column" alignItems="center">
        <Grid sx={{ width: 320, height: 36, fontSize: "2px" }}>
          <HeaderGrid
            container
            direction="row"
            // justifyContent="flex-start"
            // className={classes.headerGrid}
          >
            <Grid size={{ xs: 12 }}>
              {items === null ? (
                <TitleTypo>{t("payments.acceptedPayMethods")}</TitleTypo>
              ) : (
                <TitleTypo>{t("payments.paymentMethod")}</TitleTypo>
              )}
            </Grid>
          </HeaderGrid>
        </Grid>
        <Grid>
          {/* {items === null ? ( */}
          <HeaderGrid
            container
            // direction="row"
            // alignItems="center"
            sx={{ display: "flex", width: "330px" }}
            // className={classes.headerGrid}
          >
            <Grid style={{ paddingRight: 10 }}>
              <CreditCardHolder>
                <CreditCard src={`${Mastercard_Logo}`} />
              </CreditCardHolder>
            </Grid>
            <Grid style={{ paddingRight: 10 }}>
              <CreditCardHolder>
                <CreditCard src={`${Visa_Logo}`} />
              </CreditCardHolder>
            </Grid>
            <Grid style={{ paddingRight: 10 }}>
              <CreditCardHolder>
                <CreditCard src={`${Discover_Logo}`} />
              </CreditCardHolder>
            </Grid>
          </HeaderGrid>
          {/* ) : ( */}
          {/* <>
              <HeaderGrid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                // className={classes.headerGrid}
              >
                <Grid >
                  <CreditCardSwitch cardType={items.cardItem.cardType} />
                </Grid>
                <Grid >
                  <Typography style={{ fontSize: 18, paddingLeft: 10 }}>
                    {t("home.endingIn")} {items.cardItem.ccLastFour}
                  </Typography>
                </Grid>
              </HeaderGrid>
              <HeaderGrid
                
                style={{ paddingTop: 8 }}
                // className={classes.headerGrid}
              >
                <Typography style={{ fontType: "italic" }}>
                  {t("payments.redoMessage")}
                </Typography>
              </HeaderGrid>
            </> */}
          {/* )} */}
        </Grid>
        <Grid
          container
          direction="column"
          alignItems={isXtraSmall ? "center" : null}
        >
          <Grid style={{ marginTop: 20 }}>
            <form
              //method="post"
              id="verifyCardForm"
              onSubmit={() => SubmitHandler(this)}
            >
              {/* Items returned from SlimCD */}
              <input type="hidden" name="gateid" id="gateid" value="" />
              <input type="hidden" name="last4" id="last4" value="" />
              <input type="hidden" name="cardtype" id="cardtype" value="" />

              <CardHolder>
                <Grid container direction="row" alignItems="center">
                  <Grid size={{ xs: 4 }} style={{ marginTop: 6 }}>
                    <CreditCardChip src={`${CreditCardChipLogo}`} />
                  </Grid>
                  <Grid
                    size={{ xs: 8 }}
                    style={{ textAlign: "right", paddingRight: 20 }}
                  >
                    <TextField
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                        if (e.target.value.replace(/[^0-9]/g, "").length > 0) {
                          setErrors((prev) => ({ ...prev, zip: false }));
                        } else {
                          setErrors((prev) => ({ ...prev, zip: true }));
                        }
                      }}
                      variant="outlined"
                      margin="dense"
                      size="small"
                      id="zip"
                      label={t("payments.zipCode")}
                      autoFocus
                      //required
                      disabled={submitting}
                      error={errors.zip}
                      inputProps={{
                        maxLength: 5,
                        minLength: 5,
                        autoComplete: "password",
                      }}
                      style={{
                        backgroundColor: "rgba(255,255,255,0.7)",
                        width: 120,
                      }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid style={{ marginTop: 10 }}>
                  <Grid container direction="row" justifyContent="center">
                    <Grid>
                      <TextField
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );

                          if (
                            e.target.value.replace(/[^0-9]/g, "").length > 0
                          ) {
                            setErrors((prev) => ({
                              ...prev,
                              cardnumber: false,
                            }));
                          } else {
                            setErrors((prev) => ({
                              ...prev,
                              cardnumber: true,
                            }));
                          }
                        }}
                        variant="outlined"
                        margin="dense"
                        size="small"
                        id="cardnumber"
                        label={t("payments.cardNumber")}
                        //required
                        disabled={submitting}
                        error={errors.cardnumber}
                        inputProps={{
                          maxLength: 16,
                          minLength: 15,
                          autoComplete: "password",
                        }}
                        style={{
                          backgroundColor: "rgba(255,255,255,0.7)",
                          width: 280,
                        }}
                        InputLabelProps={{
                          classes: {
                            root: classes.labelRoot,
                            focused: classes.labelFocused,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid style={{ marginTop: 10 }}>
                  <Grid container direction="row">
                    <Grid size={{ xs: 3 }} style={{ paddingLeft: 20 }}>
                      <TextField
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          if (
                            e.target.value.replace(/[^0-9]/g, "").length > 0
                          ) {
                            setErrors((prev) => ({
                              ...prev,
                              cvv2: false,
                            }));
                          } else {
                            setErrors((prev) => ({
                              ...prev,
                              cvv2: true,
                            }));
                          }
                        }}
                        variant="outlined"
                        margin="dense"
                        size="small"
                        id="cvv2"
                        label="CVV2"
                        //required
                        disabled={submitting}
                        error={errors.cvv2}
                        inputProps={{
                          maxLength: 4,
                          minLength: 3,
                          autoComplete: "password",
                        }}
                        style={{
                          backgroundColor: "rgba(255,255,255,0.7)",
                          width: 80,
                        }}
                        InputLabelProps={{
                          classes: {
                            root: classes.labelRoot,
                            focused: classes.labelFocused,
                          },
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 1 }}>
                      <div style={{ marginLeft: 4, marginTop: -14 }}>
                        <Tooltip
                          placement="top"
                          open={showTooltipCvv}
                          disableFocusListener
                          onOpen={() => setShowTooltipCvv(true)}
                          onClose={() => setShowTooltipCvv(false)}
                          disableTouchListener
                          title={
                            <>
                              <Cvv2Tooltip src={`${Cvv2TooltipLogo}`} />
                            </>
                          }
                        >
                          <IconButton onClick={() => setShowTooltipCvv(!showTooltipCvv)} aria-label="info" size="large">
                            <InfoIcon />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </Grid>
                    <Grid
                      size={{ xs: 8 }}
                      style={{ textAlign: "right", paddingRight: 20 }}
                    >
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={locale}
                      >
                        <DesktopDatePicker
                          name="expire"
                          id="expire"
                          label={t("payments.expDate")}
                          // label={<StyledInputLabel>Expiration</StyledInputLabel>}
                          variant="outlined"
                          margin="dense"
                          size="small"
                          // inputFormat="MM/yyyy"
                          format="MM/yyyy"
                          disablePast
                          openTo="year"
                          views={["year", "month"]}
                          disabled={submitting}
                          value={selectedDate}
                          // onChange={setSelectedDate}

                          onChange={(newValue) => {
                            setSelectedDate(newValue);
                            if (newValue) {
                              setErrors((prev) => ({ ...prev, expire: false }));
                            } else {
                              setErrors((prev) => ({ ...prev, expire: true }));
                            }
                          }}
                          // sx={{width:156}}
                          sx={{
                            backgroundColor: "rgba(255,255,255,0.7)",
                            width: 170,
                          }}
                          // renderInput={(params) => (
                          //   <TextField
                          //     {...params}
                          //     fullWidth
                          //     required
                          //     margin="normal"
                          //     size="small"
                          //     error={errors.expire}
                          //     // InputLabelProps={{
                          //     //   //shrink: true
                          //     //   classes: {
                          //     //     root: classes.labelRoot,
                          //     //     focused: classes.labelFocused,
                          //     //   },
                          //     // }}

                          //     sx={{
                          //       backgroundColor: "rgba(255,255,255,0.7)",
                          //       width: 170,
                          //       marginTop: 9,
                          //     }}
                          //   />
                          // )}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              // required: true,
                              error: Boolean(errors.expire),
                              helperText: errors.expire?.message,
                              size: "small",
                              InputLabelProps: {
                              sx: {
                                maxWidth: 120,    
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              },
                            },
                              sx: {
                                backgroundColor: "rgba(255,255,255,0.7)",
                                width: 170,
                                marginTop: 1,
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
              </CardHolder>
              <Grid container direction="column" style={{ width: 320 }}>
                <Grid sx={{ width: "100%" }}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 2, mb: 1 }}
                  >
                    <Grid>
                      <GreenCheckbox
                        checked={selectedDefault}
                        onChange={handleCheckChange}
                        disabled={true}
                      />
                    </Grid>
                    <Grid>
                      <Typography>{t("payments.autoPayEnroll")}</Typography>
                    </Grid>

                    <Grid style={{ marginTop: -12 }}>
                      <Tooltip
                        placement="top"
                        open={showTooltip}
                        disableTouchListener
                        onOpen={() => setShowTooltip(true)}
                        onClose={() => setShowTooltip(false)}
                        disableFocusListener
                        title={
                          <WhiteTextTypography>
                            {t("payments.autoPayMessage")}
                          </WhiteTextTypography>
                        }
                      >
                        <IconButton onClick={() => setShowTooltip(!showTooltip)} aria-label="info" size="large">
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid  style={{ marginBottom: 20 }}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid style={{ paddingRight: 5 }}>
                      <Typography>{t("payments.billingCycleLabel")}</Typography>
                    </Grid>
                    <Grid style={{ paddingLeft: 5 }}>
                      <Select
                        variant="outlined"
                        value={billingDays}
                        onChange={handleBillingChange}
                        margin="dense"
                      >
                        <MenuItem value={7}>{t("payments.weekly")}</MenuItem>
                        <MenuItem value={14}>{t("payments.biweekly")}</MenuItem>
                        <MenuItem value={30}>{t("payments.monthly")}</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  textAlign="center"
                  style={{ width: 320, paddingBottom: 4 }}
                >
                  {errors.zip === true ? (
                    <Grid>
                      <RedTextTypography>
                        {t("payments.zipCodeError")}
                      </RedTextTypography>
                    </Grid>
                  ) : null}
                  {errors.cardnumber === true ? (
                    <Grid>
                      <RedTextTypography>
                        {t("payments.cardNumberError")}
                      </RedTextTypography>
                    </Grid>
                  ) : null}
                  {errors.cvv2 === true ? (
                    <Grid>
                      <RedTextTypography>
                        {t("payments.cvv2Error")}
                      </RedTextTypography>
                    </Grid>
                  ) : null}
                  {errors.expire === true ? (
                    <Grid>
                      <RedTextTypography>
                        {t("payments.expDateError")}
                      </RedTextTypography>
                    </Grid>
                  ) : null}
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ width: "100%" }}
                >
                  <Grid
                    sx={{
                      width: "100%",
                      paddingBottom: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {/* <Button
                      //   type="submit"
                      //   size="medium"
                      //   variant="contained"
                      //   color="primary"
                      //   disabled={submitting}
                      //   className={classes.submit}
                      //   style={{ width: 200, height: 50 }}
                      // >
                      //   {t("payments.verifyButton")}
                      // </Button> */}

                      <ContinueButton
                        submitting={submitting}
                        continueText={t("payments.finishBooking")}
                        isStatic={true}
                      />

                  </Grid>
                </Grid>
              </Grid>
            </form>

            {/* <Button
              sx={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
                mt: 4,
                color: `${brandColors[brand].primary}`,
              }}
              onClick={() => setActiveStep((prev) => prev - 1)}
            >
              BACK
            </Button> */}
          </Grid>
        </Grid>
      </Grid>
    </Root>
  );
}

UpsertPaymentMethod.propTypes = {
  user: PropTypes.object.isRequired,
  items: PropTypes.object,
  paymentMethod: PropTypes.array,
  // editCancel: PropTypes.func.isRequired,
  savePaymentMethod: PropTypes.func.isRequired,
  createPaymentMethod: PropTypes.func.isRequired,
  // setActiveStep: PropTypes.func,
  ccToken: PropTypes.string,
  appointmentData: PropTypes.object,
  handleUpdate: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    paymentMethod: state.paymentMethod,
  };
}

const mapDispatchToProps = {
  savePaymentMethod,
  createPaymentMethod,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpsertPaymentMethod);
